// DS: CR28M
import React from 'react';
import { useTranslation } from 'react-i18next';
import NotificationIcon from '@wix/da-ds/pkg/Icons/24x24/Notification';
import SiteHeaderIconButton from '../_partials/SiteHeaderIconButton';
var NotificationsDropdownWrapperMobile = function (_a) {
    var feedbackCount = _a.feedbackCount, isOpen = _a.isOpen, onClick = _a.onClick, biData = _a.biData, onClose = _a.onClose, isLegacyHeader = _a.isLegacyHeader, DropdownComponent = _a.notificationsDropdownComponent, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement("div", { className: className },
        React.createElement(SiteHeaderIconButton, { icon: NotificationIcon, biData: biData, onClick: onClick, ariaLabel: t('siteHeader.a11y.notifications'), count: feedbackCount }),
        isOpen && (React.createElement(DropdownComponent, { isLegacyHeader: isLegacyHeader, onClose: onClose }))));
};
NotificationsDropdownWrapperMobile.displayName =
    'NotificationsDropdownWrapperMobile';
export default NotificationsDropdownWrapperMobile;
//# sourceMappingURL=NotificationsDropdownWrapperMobile.js.map